import type { ReactNode } from "react";

interface SectionHeadingProps {
  eyebrow?: string;
  title: ReactNode;
  description?: ReactNode;
  align?: "left" | "center";
  tone?: "light" | "dark";
  className?: string;
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  align = "left",
  tone = "light",
  className = "",
}: SectionHeadingProps) {
  const isCenter = align === "center";
  const titleColor = tone === "dark" ? "text-background-50" : "text-foreground-950";
  const descColor = tone === "dark" ? "text-background-200" : "text-foreground-600";
  const eyebrowColor = tone === "dark" ? "text-primary-300" : "text-primary-700";

  return (
    <div className={`${isCenter ? "mx-auto max-w-3xl text-center" : "max-w-3xl"} ${className}`}>
      {eyebrow ? (
        <div
          className={`mb-4 flex items-center gap-3 font-label text-xs font-semibold uppercase tracking-[0.22em] ${eyebrowColor} ${
            isCenter ? "justify-center" : ""
          }`}
        >
          <span className="h-px w-8 bg-current opacity-60" />
          {eyebrow}
        </div>
      ) : null}
      <h2 className={`text-2xl font-bold leading-tight md:text-4xl ${titleColor}`}>{title}</h2>
      {description ? (
        <p className={`mt-4 text-sm leading-relaxed md:text-base ${descColor}`}>{description}</p>
      ) : null}
    </div>
  );
}